import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import SimpleBarScroll from "components/SimpleBar";
import ProductOffer from "pages/products/offers/ProductOffer";
import React from "react";

const ProductOfferDialog = ({ open, handleClose, product }) => {
  return (
    <CustomDialog
      forceFullScreen={true}
      open={open}
      handleClose={handleClose}
      heading="Add offers"
    >
      <Box sx={{ overflow: "hidden" }}>
        <SimpleBarScroll>
          <ProductOffer product={product} fullGrid={false} />
        </SimpleBarScroll>
      </Box>
    </CustomDialog>
  );
};

export default ProductOfferDialog;
